
export class CalendarEvent {
    public readonly type: string = nameof(CalendarEvent);

    public title: string = "";

    public notes: string = "";

    public startDate: Date = new Date();

    public endDate: Date = new Date();

    public readonly isCalendarEvent: true = true;
}